import { SecurityPosture } from '@augmentt-dev/ui-components'

const { SECURE_CHECK_TYPES } = SecurityPosture.constants

export const POSTURE_CHECK_EXPORT_TYPES = {
  BLOCK_LEGACY_AUTHENTICATION: 'BLOCK_LEGACY_AUTHENTICATION_REPORT',
  BLOCK_SIGN_IN_SHARED_MAILBOXES: 'BLOCK_SIGN_IN_SHARED_MAILBOXES_REPORT',
  INACTIVE_ACCOUNTS: 'INACTIVE_ACCOUNTS_REPORT',
  POWERSHELL_ACCESS_FOR_NON_ADMINS: 'POWERSHELL_ACCESS_FOR_NON_ADMINS_REPORT',
  SELF_SERVE_PASSWORD_RESET: 'SELF_SERVE_PASSWORD_RESET_REPORT',
}

export const POSTURE_CHECK_LIST_EXPORT_FROM = new Set(Object.values(POSTURE_CHECK_EXPORT_TYPES))

export const POSTURE_CHECK_EXPORT_MESSAGE_IDS = {
  [SECURE_CHECK_TYPES.BLOCK_LEGACY_AUTHENTICATION]: 'SECURE_CHECK.BLOCK_LEGACY_AUTHENTICATION',
  [SECURE_CHECK_TYPES.BLOCK_SIGN_IN_SHARED_MAILBOXES]: 'SECURE_CHECK.BLOCK_SIGN_IN_SHARED_MAILBOXES',
  [SECURE_CHECK_TYPES.INACTIVE_ACCOUNTS]: 'SECURE_CHECK.INACTIVE_ACCOUNTS',
  [SECURE_CHECK_TYPES.POWERSHELL_ACCESS_FOR_NON_ADMINS]: 'SECURE_CHECK.POWERSHELL_ACCESS_FOR_NON_ADMINS',
  [SECURE_CHECK_TYPES.SELF_SERVE_PASSWORD_RESET]: 'SECURE_CHECK.SELF_SERVE_PASSWORD_RESET',
}
